(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(fn, wait){let t;return (...a)=>{clearTimeout(t);t=setTimeout(()=>fn.apply(this,a),wait)}}

class ScrollingImages extends HTMLElement{
  constructor(){ super(); this._ro=null; this._io=null; this._raf=null; this._last=null; this._state=[]; this._useJs=false; this.paused=false; }

  connectedCallback(){
    // elements
    this.rows = this.querySelectorAll('[data-scrolling-image-content]');
    if(!this.rows.length) return;

    // settings
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    const isTouch = window.matchMedia('(pointer:coarse)').matches;
    this._useJs = isTouch;           // FORCE JS on touch devices (Android/iOS)
    if(isTouch){ this.pauseOnHover = false; this.style.setProperty('--play-state','running'); }

    // init after paint to ensure correct sizes
    requestAnimationFrame(()=>{ this.#init(); });
  }

  disconnectedCallback(){ this.#teardownObservers(); this.#stopJs(); }

  #init(){
    this.#buildClonesAndDurations();
    this.classList.add('scrolling-images--is-animated'); // desktop CSS anim on
    this.#setupObservers();
    this.#setupTouchHoldPause();

    if(this._useJs){ this.#startJs(); } else { this.#stopJs(); }
  }

  #buildClonesAndDurations(){
    const isDesktop = window.matchMedia('(min-width:480px)').matches;
    const gap = parseInt(isDesktop ? this.getAttribute('image-gap-desktop') : this.getAttribute('image-gap-mobile'), 10);
    const baseDuration = Math.max(parseFloat(getComputedStyle(this).getPropertyValue('--duration')), 1);

    this.rows.forEach(el=>{
      // remove old clones
      el.querySelectorAll('[data-is-clone="true"]').forEach(c=>c.remove());

      const items = el.querySelectorAll('[data-scrolling-image-content-item]:not([data-is-clone])');
      // compute content width from dataset widths (stable before images load)
      const total = [...items].reduce((sum,item)=>{
        const w = parseInt(isDesktop ? item.dataset.desktopWidth : item.dataset.mobileWidth, 10);
        return sum + (w + gap);
      }, 0) - gap;

      const width = el.offsetWidth || this.offsetWidth || 0;
      const groups = Math.max(2, Math.ceil((width * 1.5) / Math.max(total,1)));

      for(let i=1;i<groups;i++){
        items.forEach(item=>{ const clone=item.cloneNode(true); clone.setAttribute('data-is-clone','true'); el.appendChild(clone); });
      }

      // set per-row duration so speed stays constant regardless of clones
      const adjusted = baseDuration * groups;
      el.style.setProperty('--duration', `${adjusted}s`);
      el.style.transform = 'translate3d(0,0,0)'; // reset
    });
  }

  #setupObservers(){
    if(!this._ro){
      this._ro = new ResizeObserver(debounce(()=>{ this.#buildClonesAndDurations(); if(this._useJs){ this.#restartJs(); } }, 80));
      this._ro.observe(this);
    }
    if(!this._io && 'IntersectionObserver' in window){
      this._io = new IntersectionObserver(([entry])=>{
        if(this._useJs){
          if(entry.isIntersecting) this.#resumeJs(); else this.#pauseJs();
        } else {
          if(entry.isIntersecting) this.classList.add('scrolling-images--is-animated');
          else this.classList.remove('scrolling-images--is-animated');
        }
      }, {threshold:0.01});
      this._io.observe(this);
    }
  }

  #teardownObservers(){
    if(this._ro){ this._ro.unobserve(this); this._ro=null; }
    if(this._io){ this._io.unobserve(this); this._io=null; }
  }

  #setupTouchHoldPause(){
    if(!this.pauseOnHover) return;
    const setPaused=(p)=>{ this.paused=p; if(this._useJs){ p?this.#pauseJs():this.#resumeJs(); } };
    this.addEventListener('touchstart', ()=>setPaused(true), {passive:true});
    this.addEventListener('touchend',   ()=>setPaused(false));
    this.addEventListener('touchcancel',()=>setPaused(false));
  }

  // ---------- JS marquee (mobile) ----------
  #startJs(){
    this.#stopJs();
    const isDesktop = window.matchMedia('(min-width:480px)').matches; // usually false on touch
    const gap = parseInt(isDesktop ? this.getAttribute('image-gap-desktop') : this.getAttribute('image-gap-mobile'), 10);
    const dirProp = (getComputedStyle(this).getPropertyValue('--scroll-direction') || 'normal').trim();
    const dir = (dirProp === 'reverse') ? 1 : -1;

    const perRow = [];
    this.rows.forEach(el=>{
      const dist = el.scrollWidth + gap; // full strip + gap
      const dur = Math.max(parseFloat(getComputedStyle(el).getPropertyValue('--duration')), 1);
      const speed = dist / dur; // px/sec
      perRow.push({ el, x:0, dist, speed, dir });
      // kill CSS animation on rows so JS has full control
      el.style.animation = 'none';
      el.style.webkitAnimation = 'none';
      el.style.transform = 'translate3d(0,0,0)';
    });
    this._state = perRow;

    const loop = (now)=>{
      if(this.paused || !this._state.length){ this._raf = requestAnimationFrame(loop); return; }
      if(!this._last){ this._last = now; this._raf = requestAnimationFrame(loop); return; }
      const dt = (now - this._last)/1000; this._last = now;

      this._state.forEach(s=>{
        s.x += s.dir * s.speed * dt;
        if(s.dir < 0 && s.x <= -s.dist) s.x = 0;
        if(s.dir > 0 && s.x >= 0)      s.x = -s.dist;
        s.el.style.transform = `translate3d(${s.x}px,0,0)`;
      });
      this._raf = requestAnimationFrame(loop);
    };
    this._raf = requestAnimationFrame(loop);
  }

  #pauseJs(){ this.paused = true; }
  #resumeJs(){ this.paused = false; }
  #restartJs(){ this.#startJs(); }
  #stopJs(){
    if(this._raf){ cancelAnimationFrame(this._raf); this._raf=null; }
    this._last=null; this._state=[];
    this.rows?.forEach(el=>{
      el.style.removeProperty('transform');
      el.style.removeProperty('animation');
      el.style.removeProperty('-webkit-animation');
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);

  } catch(e) { console.error(e); }
})();
})();
